module.exports = __webpack_public_path__ + "img/jpm_icons2.5b883393.svg";